<div class="quotation-comparative-table">
  <p-table
    *ngIf="tableService.showProductsRequired() && tableService.showProductsRequired().length > 0"
    [value]="tableService.showProductsRequired()"
    [paginator]="false"
    [showGridlines]="true"
    styleClass="p-datatable-sm cs-datatable-comparative"
    [tableStyle]="{ 'min-width': '100%' }"
  >
    <ng-template pTemplate="header">
      <!-- Main header row -->
      <tr>
        <th rowspan="2" class="description-column">DESCRIPCION</th>
        <th rowspan="2" class="uom-column">UNS</th>
        <th rowspan="2" class="quantity-column">CANTIDAD</th>
        <th *ngFor="let column of tableService.quotationsColumns(); trackBy: trackByQuotationId" [colSpan]="2" class="provider-header">
          <div class="provider-header-content">
            <span>{{ column.providerName }}</span>
            <button type="button" class="edit-btn p-button-text p-button-sm">
              <i class="pi pi-pencil"></i>
            </button>
          </div>
        </th>
      </tr>
      <!-- Sub-header row for PU and PT -->
      <tr>
        <ng-container *ngFor="let column of tableService.quotationsColumns(); trackBy: trackByQuotationId">
          <th class="price-header">PU</th>
          <th class="price-header">PT</th>
        </ng-container>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
      <tr>
        <!-- Description column -->
        <td class="description-cell">{{ product.itemCode }}</td>

        <!-- UOM column -->
        <td class="uom-cell">{{ getUomLabel(product.uom) }}</td>

        <!-- Quantity column -->
        <td class="quantity-cell">{{ product.quantity | number: '1.2-2' }}</td>

        <!-- Price columns for each provider -->
        <ng-container *ngFor="let column of tableService.quotationsColumns(); trackBy: trackByQuotationId">
          <ng-container *ngIf="column.items[rowIndex] as item">
            <!-- Unit Price -->
            <td
              class="price-cell"
              [ngClass]="{
                'lowest-price': item.isLowestPrice && item.unitPrice !== null,
                'no-quote': item.unitPrice === null,
              }"
            >
              <span *ngIf="item.unitPrice !== null">L {{ item.unitPrice | number: '1.2-2' }}</span>
              <span *ngIf="item.unitPrice === null">-</span>
            </td>

            <!-- Total Price -->
            <td
              class="price-cell total-price-cell"
              [ngClass]="{
                'lowest-price': item.isLowestPrice && item.totalPrice !== null,
                'no-quote': item.totalPrice === null,
              }"
            >
              <div class="total-price-content">
                <span *ngIf="item.totalPrice !== null">L {{ item.totalPrice | number: '1.2-2' }}</span>
                <span *ngIf="item.totalPrice === null">-</span>
                <button *ngIf="item.files && item.files.length > 0" type="button" class="file-btn p-button-text p-button-sm" pTooltip="Ver archivos adjuntos" tooltipPosition="top">
                  <i class="pi pi-paperclip"></i>
                </button>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>

    <!-- Footer with Create Purchase Order buttons -->
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="3" class="empty-footer-cell"></td>
        <ng-container *ngFor="let column of tableService.quotationsColumns(); trackBy: trackByQuotationId">
          <td colspan="2" class="footer-action-cell">
            <div class="footer-button-container">
              <p-button *ngIf="column.isProviderSaved" label="Create Purchase Order" [outlined]="true" size="small" severity="success" (onClick)="onCreatePurchaseOrder(column)" />
              <div *ngIf="!column.isProviderSaved" class="provider-warning">
                <i class="pi pi-exclamation-triangle"></i>
                <span>Save Provider Before Creating Purchase Order</span>
              </div>
            </div>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="!tableService.showProductsRequired() || tableService.showProductsRequired().length === 0" class="no-data-message">
    <p>No hay cotizaciones para mostrar. Por favor agregue cotizaciones.</p>
  </div>
</div>
